<template>
  <form class="mt" @submit.prevent="onSubmit">
    <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">{{errorMessage}}</b-alert>
    <div class="form-group" v-if="item && item.id">
      <label for="id">ID: {{item.id}}</label>
    </div>
    <div class="form-group">
      <label for="name">Area</label>
      <input
        class="form-control"
        type="text"
        name="name"
        id="name"
        placeholder="Area"
        v-validate="'required'"
        v-model="item.name"
        autocomplete="off"
      />
    </div>
    <!-- <div class="form-group">
      <label for="description">Descripción</label>
      <textarea
        name="description"
        id="description"
        rows="5"
        class="form-control"
        placeholder="Descripción"
        v-validate="'required'"
        v-model="item.description"
      ></textarea>
    </div>-->
    <div class="clearfix">
      <div class="btn-toolbar float-right pb-4">
        <base-button
          native-type="submit"
          type="primary"
          class="mb-3"
          size="sm"
          block
          :loading="s_loading"
        >Guardar</base-button>
      </div>
    </div>
  </form>
</template>

<script>
import BaseComponent from "@/pages/components/BaseComponent";
export default {
  extends: BaseComponent,
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      errorMessage: ""
    };
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.veeFields).some(
        key => this.veeFields[key].invalid
      );
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.s_loading = true;
          if (!this.item.id) {
            this.axioPost({
              url: "Department/AddAsync",
              value: this.item
            });
          } else {
            this.axioPut({
              url: "Department/UpdateAsync",
              value: this.item
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
